// Inline Quick Add Handler
document.addEventListener('click', (event) => {
  const toggleButton = event.target.closest('[data-quick-add-toggle]');
  if (!toggleButton) return;

  const relatedCarousel = toggleButton.closest('[data-quick-add-active-slide-only]');
  if (relatedCarousel) {
    const slide = toggleButton.closest('.swiper-slide');
    if (!slide || slide.getAttribute('aria-hidden') === 'true' || slide.hasAttribute('inert')) return;
  }

  const productId = toggleButton.getAttribute('data-product-id');
  if (!productId) return;

  const quickAddModal = document.getElementById(`QuickAdd-${productId}`);
  const modalContent = quickAddModal?.querySelector('.quick-add-modal__content');
  const contentContainer = quickAddModal?.querySelector('[id^="QuickAddInfo-"]');
  const closeButton = quickAddModal?.querySelector('.quick-add-modal__toggle');

  if (!quickAddModal || !modalContent || !contentContainer) return;

  // Toggle visibility
  const isHidden = modalContent.hasAttribute('hidden');
  
  if (isHidden) {
    // Close any other inline modals before opening this one
    if (typeof window.closeOtherQuickAddModals === 'function') {
      window.closeOtherQuickAddModals(productId);
    }

    // Show inline container
    modalContent.removeAttribute('hidden');
    toggleButton.setAttribute('aria-expanded', 'true');
    if (typeof quickAddModal.show === 'function') {
      quickAddModal.show(toggleButton);
    }
    
    // Add active class to parent li.grid__item
    const parentListItem = toggleButton.closest('li.grid__item');
    if (parentListItem) {
      parentListItem.classList.add('active');
    }

    // If this quick-add lives inside a Swiper carousel, temporarily lock slide movement
    const swiperContainer = toggleButton.closest('.swiper-container-new');
    const swiperInstance = swiperContainer && swiperContainer.swiper ? swiperContainer.swiper : null;
    if (swiperInstance) {
      if (!swiperInstance._quickAddPrevConfig) {
        swiperInstance._quickAddPrevConfig = {
          allowTouchMove: swiperInstance.allowTouchMove,
          allowSlideNext: swiperInstance.allowSlideNext,
          allowSlidePrev: swiperInstance.allowSlidePrev,
          mousewheelEnabled:
            !!(swiperInstance.mousewheel && swiperInstance.mousewheel.enabled),
        };
      }
      swiperInstance.allowTouchMove = false;
      swiperInstance.allowSlideNext = false;
      swiperInstance.allowSlidePrev = false;
      if (swiperInstance.mousewheel && typeof swiperInstance.mousewheel.disable === 'function') {
        swiperInstance.mousewheel.disable();
      }
    }
    
    // Load product info if not already loaded
    if (!contentContainer.hasAttribute('data-loaded')) {
      toggleButton.setAttribute('aria-disabled', 'true');
      toggleButton.classList.add('loading');
      const spinner = toggleButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(toggleButton.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector('product-info');

          if (productElement) {
             productElement.querySelectorAll('.product-form__input--swatch, #size_guide-popup').forEach(el => el.remove());
            preprocessHTML(productElement, contentContainer, productId);
            contentContainer.classList.add('quick-add-modal__content-info--loading');
            // ❗ REMOVE BEFORE injecting
         
            HTMLUpdateUtility.setInnerHTML(contentContainer, productElement.outerHTML);
            contentContainer.setAttribute('data-loaded', 'true');
            
            // Ensure the product-info element is properly scoped to this modal
            requestAnimationFrame(() => {
              setTimeout(() => {
                const insertedProductInfo = contentContainer.querySelector('product-info');
                if (insertedProductInfo) {
                  // Set a unique identifier to ensure variant changes are scoped to this modal
                  insertedProductInfo.dataset.quickAddProductId = productId;
                  
                  // Also set it on the quick-add-modal for reference
                  if (quickAddModal) {
                    quickAddModal.dataset.productId = productId;
                  }
                  
                  // Ensure variant-selects is also scoped to this modal
                  const variantSelects = insertedProductInfo.querySelector('variant-selects');
                  if (variantSelects) {
                    variantSelects.dataset.quickAddProductId = productId;
                    
                    // Intercept the change event on variant-selects to add product ID to the published event
                    variantSelects.addEventListener('change', function(event) {
                      // This will run before the variant-selects publishes the event
                      // We'll add the product ID to the event target for later reference
                      event.target.dataset.quickAddProductId = productId;
                    }, true);
                  }
                  
                  // Wrap the product-info's handleOptionValueChange to add scoping
                  // We need to do this by intercepting the subscription
                  const productInfoInstance = insertedProductInfo;
                  
                  // The product-info subscribes in connectedCallback, so we need to wait for that
                  // Then we can wrap the handler
                  const checkAndWrap = () => {
                    // Check if the method exists (it should after connectedCallback)
                    if (productInfoInstance.handleOptionValueChange) {
                      const originalMethod = productInfoInstance.handleOptionValueChange.bind(productInfoInstance);
                      
                      // Create a wrapped version
                      productInfoInstance.handleOptionValueChange = function(eventData) {
                        const { data: { event, target } } = eventData;
                        
                        // First check: ensure event.target is within this product-info
                        if (!this.contains(event.target)) {
                          return;
                        }
                        
                        // Second check: ensure the variant-selects that triggered this belongs to this modal
                        const variantSelectsElement = target.closest('variant-selects');
                        if (variantSelectsElement) {
                          const variantSelectsProductId = variantSelectsElement.dataset.quickAddProductId;
                          const productInfoProductId = this.dataset.quickAddProductId;
                          
                          // If both have product IDs, they must match
                          if (variantSelectsProductId && productInfoProductId) {
                            if (variantSelectsProductId !== productInfoProductId) {
                              // This event is for a different modal, ignore it
                              return;
                            }
                          }
                        }
                        
                        // Also check the event target itself
                        if (event.target && event.target.dataset.quickAddProductId) {
                          if (event.target.dataset.quickAddProductId !== this.dataset.quickAddProductId) {
                            return;
                          }
                        }
                        
                        // All checks passed, call original method
                        return originalMethod(eventData);
                      };
                    } else {
                      // Method not ready yet, try again
                      setTimeout(checkAndWrap, 50);
                    }
                  };
                  
                  // Start checking after a short delay to allow connectedCallback to run
                  setTimeout(checkAndWrap, 150);
                }
                
                // Reorder elements: Move price after variant-selects but before product-form
                // Wait a bit longer to ensure all elements are rendered, then wait 1s before showing
                setTimeout(() => {
                  reorderQuickAddElements(insertedProductInfo);
                  moveQuickAddOptionErrorsToTitles(insertedProductInfo);
                  contentContainer.classList.remove('quick-add-modal__content-info--loading');
                  setupQuickAddScrollPreservation(contentContainer);
                  setupQuickAddPreProcessCallback(insertedProductInfo, productId);
                  setupQuickAddVariantSelectsObserver(insertedProductInfo, productId);
                }, 100);
              }, 100);
            });

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
          }
        })
        .finally(() => {
          toggleButton.removeAttribute('aria-disabled');
          toggleButton.classList.remove('loading');
          const spinner = toggleButton.querySelector('.loading__spinner');
          const parentgrid = toggleButton.closest('li.grid__item');
          if (parentgrid) parentgrid.classList.add('grid-loaded');
          if (spinner) spinner.classList.add('hidden');

        });
    } else {
      moveQuickAddOptionErrorsToTitles(contentContainer.querySelector('product-info'));
    }
  } else {
    quickAddModal.hide();
    return;
  }
});

// Close button handler
document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.quick-add-modal__toggle--inline');
  if (!closeButton) return;

  const quickAddModal = closeButton.closest('quick-add-modal');
  if (!quickAddModal) return;

  quickAddModal.hide(true);
});

if (!window.closeOtherQuickAddModals) {
  function closeOtherQuickAddModals(currentProductId) {
    const allQuickAddModals = document.querySelectorAll('quick-add-modal.quick-add-modal--inline');

    allQuickAddModals.forEach((modal) => {
      const modalProductId = modal.dataset.productId || modal.id.replace('QuickAdd-', '');
      if (modalProductId === currentProductId) return;

      if (typeof modal.hide === 'function') {
        modal.hide(true);
        return;
      }

      const modalContent = modal.querySelector('.quick-add-modal__content');
      const contentContainer = modal.querySelector('[id^="QuickAddInfo-"]');

      if (modalContent) {
        modalContent.setAttribute('hidden', '');
      }

      if (contentContainer) {
        contentContainer.removeAttribute('data-loaded');
        contentContainer.innerHTML = '';
      }

      const toggleButton = document.querySelector(
        `[data-quick-add-toggle][data-product-id="${modalProductId}"]`
      );

      if (toggleButton) {
        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.removeAttribute('aria-disabled');
        toggleButton.classList.remove('loading');

        const spinner = toggleButton.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');

        const parentListItem = toggleButton.closest('li.grid__item');
        if (parentListItem){ parentListItem.classList.remove('active');
          parentListItem.classList.remove('grid-loaded');
        }

      }
    });
  }

  window.closeOtherQuickAddModals = closeOtherQuickAddModals;
}

function preprocessHTML(productElement, container, productId) {
  if (!productElement) return;

  productElement.classList.forEach((classApplied) => {
    if (classApplied.startsWith('color-') || classApplied === 'gradient')
      container.classList.add(classApplied);
  });
  
  // Use the provided productId or try to get it from the container's parent modal
  if (!productId) {
    const quickAddModal = container.closest('quick-add-modal');
    productId = quickAddModal ? quickAddModal.id.replace('QuickAdd-', '') : null;
  }
  
  preventDuplicatedIDs(productElement, productId);
  removeDOMElements(productElement);
  preventVariantURLSwitching(productElement);
  
  // Set product ID on product-info element for scoping
  if (productId) {
    productElement.dataset.quickAddProductId = productId;
  }
}

function preventVariantURLSwitching(productElement) {
  productElement.setAttribute('data-update-url', 'false');
}

/**
 * Prevents page scroll when selecting variants in quick-add modal (fixes PDP conflict)
 */
function setupQuickAddScrollPreservation(contentContainer) {
  if (contentContainer.dataset.scrollPreservationSetup === 'true') return;
  contentContainer.dataset.scrollPreservationSetup = 'true';

  contentContainer.addEventListener('pointerdown', (e) => {
    if (e.target.closest('fieldset.product-form__input') && (e.target.matches('label, input, select') || e.target.closest('label'))) {
      contentContainer._quickAddScrollY = window.scrollY;
    }
  }, true);

  contentContainer.addEventListener('focusin', (e) => {
    if (e.target.closest('fieldset.product-form__input') && contentContainer._quickAddScrollY != null) {
      requestAnimationFrame(() => {
        window.scrollTo(0, contentContainer._quickAddScrollY);
        contentContainer._quickAddScrollY = null;
      });
    }
  }, true);
}

/**
 * Uniquifies IDs in variant-selects when it gets replaced (prevents PDP conflict)
 */
function setupQuickAddPreProcessCallback(productInfo, productId) {
  if (productInfo.dataset.quickAddPreProcessSetup === 'true') return;
  productInfo.dataset.quickAddPreProcessSetup = 'true';

  if (typeof productInfo.addPreProcessCallback !== 'function') return;

  const baseSectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
  const newSectionId = `quickadd-${productId}-${baseSectionId}`;

  productInfo.addPreProcessCallback((incomingNode) => {
    const nodeToProcess = incomingNode?.nodeName === 'VARIANT-SELECTS' ? incomingNode : incomingNode?.querySelector?.('variant-selects') || incomingNode;
    if (!nodeToProcess || !productId || !baseSectionId) return;

    nodeToProcess.innerHTML = nodeToProcess.innerHTML.replaceAll(baseSectionId, newSectionId);
    Array.from(nodeToProcess.querySelectorAll('*')).forEach((el) => {
      Array.from(el.attributes || []).forEach((attr) => {
        if (attr.value && attr.value.includes(baseSectionId)) {
          el.setAttribute(attr.name, attr.value.replaceAll(baseSectionId, newSectionId));
        }
      });
    });
        // 🔥 ADD THIS: REMOVE UNWANTED ELEMENTS ON EVERY RE-RENDER
    incomingNode.querySelectorAll(
      '.product-form__input--swatch, #size_guide-popup'
    ).forEach(el => el.remove());
  });
}

/**
 * Ensures new variant-selects (after viewTransition replace) keeps quickAddProductId
 */
function setupQuickAddVariantSelectsObserver(productInfo, productId) {
  if (productInfo.dataset.quickAddObserverSetup === 'true') return;
  productInfo.dataset.quickAddObserverSetup = 'true';

  const ensureVariantSelectsScoped = (variantSelects) => {
    if (!variantSelects || variantSelects.dataset.quickAddProductId === productId) return;
    variantSelects.dataset.quickAddProductId = productId;
    variantSelects.addEventListener('change', function(event) {
      event.target.dataset.quickAddProductId = productId;
    }, true);
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const vs = node.nodeName === 'VARIANT-SELECTS' ? node : node.querySelector?.('variant-selects');
          if (vs) {
            ensureVariantSelectsScoped(vs);
            moveQuickAddOptionErrorsToTitles(productInfo);
          }
        }
      });
    });
  });

  observer.observe(productInfo, { childList: true, subtree: true });
}

function removeDOMElements(productElement) {
  const pickupAvailability = productElement.querySelector('pickup-availability');
  if (pickupAvailability) pickupAvailability.remove();

  const productModal = productElement.querySelector('product-modal');
  if (productModal) productModal.remove();

  const modalDialog = productElement.querySelectorAll('modal-dialog');
  if (modalDialog) modalDialog.forEach((modal) => modal.remove());
}

function reorderQuickAddElements(productInfo) {
  if (!productInfo) return;
  
  // Find variant-selects
  const variantSelects = productInfo.querySelector('variant-selects');
  
  // Find price element (it has id starting with "price-")
  const priceElement = productInfo.querySelector('[id^="price-"]');
  
  // Find product-form
  const productForm = productInfo.querySelector('product-form');
  
  if (!variantSelects || !priceElement) return;
  
  // Get the parent container (product__info-container)
  const infoContainer = productInfo.querySelector('.product__info-container');
  if (!infoContainer) return;
  
  // Check current order
  const allChildren = Array.from(infoContainer.children);
  const variantIndex = allChildren.indexOf(variantSelects);
  const priceIndex = allChildren.indexOf(priceElement);
  const formIndex = productForm ? allChildren.indexOf(productForm) : -1;
  
  // If price is already after variant-selects and (before product-form or product-form doesn't exist), skip
  if (priceIndex > variantIndex && (formIndex === -1 || priceIndex < formIndex)) {
    return; // Already in correct position
  }
  
  // Remove price from current position
  priceElement.remove();
  
  // Insert price after variant-selects
  if (productForm && formIndex > variantIndex) {
    // Insert before product-form if it exists and comes after variant-selects
    productForm.insertAdjacentElement('beforebegin', priceElement);
  } else {
    // Insert after variant-selects
    variantSelects.insertAdjacentElement('afterend', priceElement);
  }
}

/* Mobile card Shop More: place option errors next to the option title (PDP markup unchanged) */
function moveQuickAddOptionErrorsToTitles(productInfo) {
  if (!productInfo) return;

  productInfo
    .querySelectorAll(
      '.product-form__input--pill[data-required-option], .product-form__input--dropdown[data-required-option]'
    )
    .forEach((optionInput) => {
      const errorEl = optionInput.querySelector(':scope > .variant-option-error');
      const titleEl = optionInput.querySelector(':scope > legend.form__label, :scope > .form__label');
      if (!errorEl || !titleEl || titleEl.contains(errorEl)) return;
      titleEl.appendChild(errorEl);
    });
}

function preventDuplicatedIDs(productElement, productId) {
  const sectionId = productElement.dataset.section;
  if (!sectionId) return;

  // Create unique ID for this specific modal instance using product ID
  const oldId = sectionId;
  const newId = productId ? `quickadd-${productId}-${sectionId}` : `quickadd-${sectionId}`;
  
  // Replace all occurrences of the old section ID with the new unique ID
  productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
  
  // Update all attributes that reference the section ID
  Array.from(productElement.attributes).forEach((attribute) => {
    if (attribute.value && attribute.value.includes(oldId)) {
      productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
    }
  });

  // Update the data-section attribute to the new unique ID
  productElement.dataset.section = newId;
  productElement.dataset.originalSection = sectionId;
  
  // Also update the product-info element's ID if it exists
  if (productElement.id) {
    productElement.id = productElement.id.replace(oldId, newId);
  }
}

// Keep modal support for backward compatibility (for non-inline modals)
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends HTMLElement {
      constructor() {
        super();
      }

      show(opener) {
        if (this.classList.contains('quick-add-modal--inline')) {
          const modalContent = this.querySelector('.quick-add-modal__content');
          if (!modalContent) return;

          this.openedBy = opener || this.openedBy;
          modalContent.removeAttribute('hidden');

          modalContent.setAttribute('role', 'dialog');
          modalContent.setAttribute('aria-modal', 'true');

          // Ensure modal content itself is focusable if needed
          if (!modalContent.hasAttribute('tabindex')) {
            modalContent.setAttribute('tabindex', '-1');
          }

          const closeButton = this.querySelector('.quick-add-modal__toggle');
          const firstFocus = closeButton || modalContent;

          // Initial focus + trap (content may still be loading asynchronously)
       if (firstFocus && typeof firstFocus.focus === 'function') {
          firstFocus.focus();
        }

         

          // Close on ESC
          if (!this._onQuickAddKeydown) {
            this._onQuickAddKeydown = (e) => {
              if (e.code?.toUpperCase() !== 'ESCAPE') return;
              this.hide();
            };
          }
          document.addEventListener('keydown', this._onQuickAddKeydown);
        }
      }

      hide(preventFocus = false) {
        if (this.classList.contains('quick-add-modal--inline')) {
          const productId = this.dataset.productId || this.id.replace('QuickAdd-', '');
          const modalContent = this.querySelector('.quick-add-modal__content');
          const contentContainer = this.querySelector('[id^="QuickAddInfo-"]');

          if (modalContent) {
            modalContent.setAttribute('hidden', '');
          }

          if (contentContainer) {
            contentContainer.removeAttribute('data-loaded');
            contentContainer.innerHTML = '';
          }

          // Prefer the actual opener button so we don't accidentally update a different
          // product card that shares the same data-product-id elsewhere on the page.
          const openerButton =
            this.openedBy && this.openedBy.closest
              ? this.openedBy.closest('[data-quick-add-toggle]')
              : null;

          const toggleButton =
            openerButton ||
            document.querySelector(`[data-quick-add-toggle][data-product-id="${productId}"]`);

          if (toggleButton) {
            toggleButton.setAttribute('aria-expanded', 'false');
            toggleButton.removeAttribute('aria-disabled');
            toggleButton.classList.remove('loading');

            const spinner = toggleButton.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            const parentListItem = toggleButton.closest('li.grid__item');
            if (parentListItem) {parentListItem.classList.remove('active');
              parentListItem.classList.remove('grid-loaded');
            }

            // If this quick-add lives inside a Swiper carousel, restore slide movement
            const swiperContainer = toggleButton.closest('.swiper-container-new');
            const swiperInstance = swiperContainer && swiperContainer.swiper ? swiperContainer.swiper : null;
            if (swiperInstance && swiperInstance._quickAddPrevConfig) {
              swiperInstance.allowTouchMove = swiperInstance._quickAddPrevConfig.allowTouchMove;
              swiperInstance.allowSlideNext = swiperInstance._quickAddPrevConfig.allowSlideNext;
              swiperInstance.allowSlidePrev = swiperInstance._quickAddPrevConfig.allowSlidePrev;
              if (
                swiperInstance.mousewheel &&
                typeof swiperInstance.mousewheel.enable === 'function'
              ) {
                if (swiperInstance._quickAddPrevConfig.mousewheelEnabled) {
                  swiperInstance.mousewheel.enable();
                }
              }
              delete swiperInstance._quickAddPrevConfig;
            }

            if (!preventFocus && typeof toggleButton.focus === 'function') {
              toggleButton.focus();
            }
          }

      
          if (this._onQuickAddKeydown) {
            document.removeEventListener('keydown', this._onQuickAddKeydown);
          }
          if (this._quickAddTrapObserver) {
            this._quickAddTrapObserver.disconnect();
          }

          document.body.dispatchEvent(new CustomEvent('modalClosed'));
          return;
        }

        document.body.dispatchEvent(new CustomEvent('modalClosed'));
      }
    }
  );
}
